

import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css";
import logo from "../../assets/logo.jpg";

const HomePage = () => {
  return (
    <div className="home-container">

      {/* HERO SECTION */}
      <section className="hero">

        {/* Background Image Slider */}
        <div className="hero-slider">
          <div className="slide slide1"></div>
          <div className="slide slide2"></div>
          <div className="slide slide3"></div>
          <div className="slide slide4"></div>
        </div>

        {/* Overlay */}
        <div className="hero-overlay"></div>

        {/* Hero Content */}
        <div className="hero-content">

          <div className="logo-wrapper">
            <img src={logo} alt="Vetrieq Logo" className="logo" />
          </div>

          <h1>Vetrieq Global Exports</h1>

          <p className="tagline">
            Delivering Quality. Building Trust. Connecting India to the World.
          </p>

          <div className="hero-buttons">

            <Link to="/about" className="btn-primary">
              Learn More
            </Link>

            <Link to="/products" className="btn-outline">
              Explore Products
            </Link>

          </div>

        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about-preview">

        <div className="about-image">
          <img
            src="https://images.unsplash.com/photo-1552664730-d307ca884978"
            alt="Export Business"
          />
        </div>

        <div className="about-content">

          <h2>Who We Are</h2>

          <p>
            Vetrieq carries a proud legacy of 45+ years rooted in trust,
            ethics, and quality. We bring high-grade Indian products to
            global markets with a commitment to reliability and excellence.
          </p>

          <div className="stats-container">

            <div className="stat-card">
              <h3>45+</h3>
              <span>Years Legacy</span>
            </div>

            <div className="stat-card">
              <h3>50+</h3>
              <span>Products</span>
            </div>

            <div className="stat-card">
              <h3>Global</h3>
              <span>Export Network</span>
            </div>

          </div>

        </div>
      </section>

      {/* PRODUCTS SECTION */}
      <section className="products-preview">

        <h2>Our Product Range</h2>

        <p>
          Spices • Food Ingredients • Eco Friendly Products • Handicrafts •
          Traditional Indian Goods
        </p>

        <div className="products-grid">

          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1596040033229-a9821ebd058d"
              alt="Spices"
            />
            <h3>Indian Spices</h3>
          </div>

          <div className="product-card">
            <img
              src="https://images.unsplash.com/photo-1542838132-92c53300491e"
              alt="Food Products"
            />
            <h3>Vegetables & Food Products</h3>
          </div>

          <div className="product-card">
            <img
             src="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85"
             alt="Handicrafts Products"
            />
            <h3>Handicrafts Products</h3>
          </div>

        </div>

        <Link to="/products" className="btn-secondary">
          Explore Products
        </Link>

      </section>

      {/* WHY CHOOSE US */}
      <section className="why-choose">

        <h2>Why Choose Vetrieq?</h2>

        <div className="why-grid">

          <div className="why-card">
            <span>🌍</span>
            <h3>Global Export</h3>
            <p>
              Serving international markets with reliable export solutions.
            </p>
          </div>

          <div className="why-card">
            <span>✅</span>
            <h3>Trusted Quality</h3>
            <p>
              Products verified with export-grade quality standards.
            </p>
          </div>

          <div className="why-card">
            <span>🚢</span>
            <h3>Reliable Shipping</h3>
            <p>
              Timely delivery with secure shipment methods worldwide.
            </p>
          </div>

        </div>

      </section>

    </div>
  );
};

export default HomePage;